import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {reduxForm, Field} from 'redux-form';
import { browserHistory } from 'react-router';
import {FormFieldHelpers as Form} from '../../../../../helpers';
import validate from '../../../../../helpers/SyncValidator';
import ThanksModal from '../../../../common/elements/ThanksModal';
import GenericModal from '../../../../common/elements/GenericModal';

class PasswordReset extends Component {

    constructor(props) {
        super(props);
        this.handleSubmitPassword = this.handleSubmitPassword.bind(this);
        const isFirstLogin = ( parseInt(localStorage.getItem('first_login'),10) === 1 ) && true;
        this.state = {
            isOpen: false,
			isGenericModalOpen: isFirstLogin,
        };
    }


    handleOnClose(e) {
        e.preventDefault();
        this.setState({isOpen: false});
        if( parseInt( localStorage.getItem( 'changed_password' ), 10 ) === 1 ){
            browserHistory.push(`/`);
		} else {
            browserHistory.push(`/`);
		}
    }

    handleGenericModalClose(e) {
        e.preventDefault();
        this.setState({isGenericModalOpen: false, });
    }

    handleSubmitPassword( password ) {
        const { handleFormSubmit } = this.props;
        this.setState({isOpen: true});
		handleFormSubmit( password );
    }


	render() {

		const { submitting, submitFailed, submitSucceeded, pristine, handleSubmit } = this.props;
        if( submitSucceeded && parseInt( localStorage.getItem( 'first_login' ), 10  ) === 1 ) {
            localStorage.setItem('first_login', 0);
            localStorage.setItem( 'changed_password', 1 );
		}
		return (
			<div>

			<form className="row form-preferences" onSubmit={ handleSubmit( this.handleSubmitPassword ) }>
				<div className="col-xs-12 col-md-6">
					<div className="field-box">
						<Field
							name="password"
							label="New password"
							placeholder="Enter new password"
							component={ Form.passwordField }
						/>
					</div>
					<div className="field-box">
						<Field
							name="password_confirmation"
							label="Password Confirmation"
							placeholder="Confirm password"
							component={ Form.passwordField }
						/>
					</div>
				</div>
				<div className="col-xs-12">
					<button action="submit" disabled={ pristine || submitting } className="theme-button">
						Change password
					</button>
				</div>
			</form>

				<ThanksModal isOpen={ this.state.isOpen } onClose={ (e) => this.handleOnClose(e) }
							 message="Your password has been changed."/>

				<GenericModal isOpen={ this.state.isGenericModalOpen } onClose={ (e) => this.handleGenericModalClose(e) }
							  header="Change Password."
							  message="Please change your password in the form below before continuing."/>
			</div>
		)
	}
}

PasswordReset.propTypes = {
	submitting: PropTypes.bool,
	submitFailed: PropTypes.bool,
	submitSucceeded: PropTypes.bool,
	pristine: PropTypes.bool,
	handleSubmit: PropTypes.func
}

PasswordReset = reduxForm({form: 'password-reset', validate})(PasswordReset);

export default PasswordReset;


// WEBPACK FOOTER //
// src/client/components/site/features/account/basic/PasswordReset.js